import { type NovelItem, NovelItem_Status, SearchNovelsRequest } from '@app/_proto/Protos/novels';
import { NovelsClient } from '@app/_proto/Protos/novels.client';
import { useGrpcApiWithQuery } from '@app/libs/api';
import { useGrpcRequest } from '@app/libs/grpc';

type UseSneakPeeksParam = {
    enabled?: boolean;
};

type UseSneakPeeksReturn = {
    data: NovelItem[] | undefined;
    isLoading: boolean;
    isSuccess: boolean;
};

export default function useSneakPeeks({ enabled }: UseSneakPeeksParam): UseSneakPeeksReturn {
    const sneakPeekNovelsRequest = useGrpcRequest(SearchNovelsRequest, {
        sneakPeek: {
            value: true,
        },
        status: NovelItem_Status.All,
        count: 25,
    });
    const { data, isLoading, isSuccess } = useGrpcApiWithQuery(
        NovelsClient,
        c => c.searchNovels,
        sneakPeekNovelsRequest,
        ['sneak-peek-novels'],
        {
            enabled,
            cacheTime: 1000 * 60 * 60 * 24, //Data cached for 24 hours
            staleTime: 1000 * 60 * 60 * 24, //Data stales in 24 hours
        }
    );

    return { data: data?.items, isLoading, isSuccess };
}
